import { Injectable, inject } from '@angular/core';
import { AuthService, UIService } from '@core/services';
import { TokenService } from '@paypoint-frontend/web-core';

@Injectable({ providedIn: 'root' })
export class AppStateService {
  private authService = inject(AuthService);
  private tokenService = inject(TokenService);
  private uiService = inject(UIService);

  isLoading(): boolean {
    return this.uiService.inProgress();
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  isTokenExpired(): boolean {
    return this.tokenService.isTokenExpired();
  }
}
